export const API_BASE_URL = 'restapi/'; // always with trailing '/'!
